<div [class.bright]="isBright">
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="page_main_sec">
            <div class="row legend-sec">
                <div class="col-lg-6 ">
                    <span class="form-field-legend">
                        <font color="red">* Fields are Mandatory</font>
                    </span>
                    <!-- <span class="form-field-legend">
                        <font color="blue"># Fields are Numeric</font>
                    </span> -->
                    <span class="form-field-legend">
                        <font color="green">## Fields are Decimal</font>
                    </span>
                </div>


            </div>

            <div class="row form-control-sec DAO_datacss">




                <div class="row selection-sec">
                    <div class="grid_panel">
                        <div class="form-container">
                            <div [formGroup]=frmRulesave>
                                <div class="DAO_datacss">
                                    <div class=" form-control-sec">
                                        <div class="">
                                            <div class="row cmnt_sec_h_100">
                                                <div class="col-lg-1"></div>
                                                <div class="col-lg-3">
                                                    <mat-form-field [style.width.%]="100">
                                                        <mat-label for="field_selection">Select Fields</mat-label>
                                                        <mat-select #mySelect formControlName="fieldselected" multiple
                                                            [(value)]="column_data" [(ngModel)]="column_data"
                                                            id="field_selection">

                                                            <mat-option [value]="">
                                                                --select--
                                                            </mat-option>
                                                            <mat-option [value]="doc.Id" *ngFor="let doc of fieldList">
                                                                {{doc.Name}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>


                                                    <app-dropdown-multiselect [lstDropdownOption]="data"
                                                        [selectedValues]="column_data">
                                                    </app-dropdown-multiselect>
                                                </div>
                                                <div class="col-lg-8 cmnt_sec_h_100">
                                                    <mat-form-field formControlName="txtdata"
                                                        style="width: 700px !important">
                                                        <textarea matInput required cols="350" rows="2" name="Rule"
                                                            placeholder="Rule" [value]="Rule_desc"
                                                            [(ngModel)]="Rule_desc" required></textarea>
                                                    </mat-form-field>
                                                </div>

                                            </div>

                                            <div class="row mt_20">
                                                <div class="col-lg-5 text-right"></div>
                                                <div class="col-lg-2 text-right">
                                                    <button class="btncss  " [class.btn_disable]="frmRulesave?.invalid"
                                                        [class.btn_primary]="!frmRulesave?.invalid"
                                                        [disabled]="frmRulesave?.invalid"
                                                        (click)="submitInvoice()">Submit</button>
                                                </div>
                                                <div class="col-lg-5 text-right"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>



        </div>
    </div>